/**
 * @generated SignedSource<<7c499839430be083f7c77af46ca03ae9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectDetailsPage_tenant$data = {
  readonly allowExternalIncentive: boolean;
  readonly defaultSurveysToUseApi: boolean;
  readonly enableRecorder: boolean;
  readonly enableSurvey: boolean;
  readonly externalIncentivePerParticipantCostUsdCents: number;
  readonly voxpopmeApiKey: string | null;
  readonly voxpopmeLiveDefaultProjectId: number | null;
  readonly vpmAccountId: number | null;
  readonly " $fragmentSpreads": FragmentRefs<"InputTags_tenant">;
  readonly " $fragmentType": "ProjectDetailsPage_tenant";
};
export type ProjectDetailsPage_tenant$key = {
  readonly " $data"?: ProjectDetailsPage_tenant$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectDetailsPage_tenant">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectDetailsPage_tenant",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultSurveysToUseApi",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowExternalIncentive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalIncentivePerParticipantCostUsdCents",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vpmAccountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "voxpopmeLiveDefaultProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "voxpopmeApiKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableSurvey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableRecorder",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InputTags_tenant"
    }
  ],
  "type": "TenantNode",
  "abstractKey": null
};

(node as any).hash = "6d4650eaa04b84b683a080e805040e16";

export default node;
